import { useCheckoutProStore } from "@/store/checkout-pro";
import { useMagasinStore } from "@/store/magasin";
import { states } from "@/components/molecules/mixins/form.mixin";

export const usePageCommanderProInfosFacturation = () => {
  const checkoutProStore = useCheckoutProStore();
  const magasinStore = useMagasinStore();

  const state = ref(states.DEFAULT)
  const cgvLink = '/legal/informations-juridiques/conditions-generales-de-vente-drivepro'
  const pdpLink = '/legal/informations-juridiques/politique-donnees-personnelles-corapro'

  const { name: magasinName } = storeToRefs(magasinStore)
  const { checkout, facturationForm, error, infoNonRetrait } = storeToRefs(checkoutProStore)

  const { setFacturationForm, processCreateCommande } = checkoutProStore;

  const save = async () => {
    try {
      state.value = states.LOADING;
      const data = await processCreateCommande();
      navigateToInternal(`/commander-pro/confirmation/${data.id}`);
      state.value = states.SUCCESS;
    } catch (error) {
      state.value = states.ERROR;
    }
  }

  return {
    state,
    cgvLink,
    pdpLink,
    magasinName,
    checkout,
    facturationForm,
    error,
    infoNonRetrait,
    setFacturationForm,
    processCreateCommande,
    save
  }
}